export class FileAttachmentClass {
    FileId : number;
    FileNameSelected : string;
    FileNameServer : string;
    Folder : string;
    FkPageId : number;
    PageName : string;
    TableName : string;
    AutoId : number;
    CrtdBy : number;
    CrtdOn : Date;
    Flag : number;
    FileSize: number;
    isHidden:boolean=false;
}
